module.exports = __webpack_public_path__ + "static/media/baking.d90a859c.jpg";